export default {
  sm: `
  Data centers where the 
  future assets stored 
  are the source of creating 
  values.
  `,
  md: `
  Data centers where the future assets stored
  are the source of creating values.
  `
};
